var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHashnode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24547_113012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.351 8.01898L15.981 1.64898C14.9251 0.593155 13.4931 0 12 0C10.5068 0 9.07481 0.593155 8.01898 1.64898L1.64898 8.01898C0.593155 9.07481 0 10.5068 0 12C0 13.4931 0.593155 14.9251 1.64898 15.981L8.01898 22.351C9.07481 23.4068 10.5068 24 12 24C13.4931 24 14.9251 23.4068 15.981 22.351L22.351 15.981C23.4068 14.9251 24 13.4931 24 12C24 10.5068 23.4068 9.07481 22.351 8.01898ZM12 15.953C11.4809 15.953 10.9668 15.8507 10.4872 15.6521C10.0076 15.4534 9.57186 15.1622 9.20479 14.7952C8.83772 14.4281 8.54654 13.9923 8.34788 13.5127C8.14923 13.0331 8.04698 12.5191 8.04698 12C8.04698 11.4809 8.14923 10.9668 8.34788 10.4872C8.54654 10.0076 8.83772 9.57186 9.20479 9.20479C9.57186 8.83772 10.0076 8.54654 10.4872 8.34788C10.9668 8.14923 11.4809 8.04698 12 8.04698C13.0484 8.04698 14.0538 8.46345 14.7952 9.20479C15.5365 9.94612 15.953 10.9516 15.953 12C15.953 13.0484 15.5365 14.0538 14.7952 14.7952C14.0538 15.5365 13.0484 15.953 12 15.953Z",
    fill: "#395BA9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24547_113012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashnode);
export default __webpack_public_path__ + "static/media/hashnode.b759b4b7452cc45c6dc750a7beb187f2.svg";
export { ForwardRef as ReactComponent };